import { useCallback, useState } from 'react';
import CarouselSlide from '@/components/blocks/GalleryCarousel/CarouselSlide';
import CarouselZoomPreview from '@/components/blocks/GalleryCarousel/CarouselZoomPreview';
import { EmblaCarousel } from '@/components/elements/Carousel/Carousel';
import Container from '@/components/global/Container';
import { IComponentBlocksGalleryCarousel, IUploadFileEntity } from '@/graphql/__generated__/global/types';

const BlockGalleryCarousel = ({ eyebrowTitle, galleryCarouselImages: images }: IComponentBlocksGalleryCarousel) => {
    const [zoomImg, setZoomImg] = useState<IUploadFileEntity | undefined>(undefined);
    const onImageClick = useCallback((img?: IUploadFileEntity) => setZoomImg((currentImg) => (currentImg !== undefined ? undefined : img)), [setZoomImg]);
    const close = useCallback(() => setZoomImg(undefined), [setZoomImg]);

    const numImages = images?.data?.length || 0;
    if (numImages === 0) {
        return null;
    }

    return (
        <>
            {eyebrowTitle && (
                <Container className="pb-4">
                    <span className="h6">{eyebrowTitle}</span>
                </Container>
            )}
            <CarouselZoomPreview close={close} image={zoomImg} />
            <Container paddingX={false} maxWidth="xl">
                <EmblaCarousel
                    emblaOptions={{
                        align: 'center',
                        slidesToScroll: 1,
                        skipSnaps: true,
                        containScroll: 'trimSnaps',
                        loop: true,
                    }}
                >
                    {({ emblaRef }) => {
                        return (
                            <EmblaCarousel.Slides ref={emblaRef} className="embla__gallery__carousel">
                                {images?.data.map((image, index) => (
                                    <CarouselSlide key={index} image={image} onClick={onImageClick} />
                                ))}
                            </EmblaCarousel.Slides>
                        );
                    }}
                </EmblaCarousel>
            </Container>
        </>
    );
};

export default BlockGalleryCarousel;
